<template>
  <Select
    class="w-full max-w-xl"
    :value="value"
    :options="employerOptions"
    :filter-option="false"
    :not-found-content="employersLoading ? 'Searching…' : 'No employers found'"
    :loading="employersLoading"
    :default-active-first-option="false"
    :show-arrow="true"
    show-search
    allow-clear
    placeholder="Search by community, name, or email"
    size="large"
    @search="handleEmployerSearch"
    @change="handleEmployerChange"
    @dropdown-visible-change="handleDropdownVisibleChange"
  />
</template>

<script>
import { Select, message } from 'ant-design-vue';
import debounce from 'lodash.debounce';
import employersApi from '@/services/apis/admin/employers.api';
import handleResErrors from '@/utils/handleResErrors';

export default {
  name: 'EmployerSelect',
  components: {
    Select,
  },
  props: {
    value: {
      type: String,
      default: undefined,
    },
  },
  emits: ['update:value'],
  data() {
    return {
      employers: [],
      employersLoading: false,
      hasLoadedInitialEmployers: false,
    };
  },
  computed: {
    employerOptions() {
      return this.employers.map((emp) => ({
        // eslint-disable-next-line no-underscore-dangle
        value: emp._id,
        label: this.formatEmployerLabel(emp),
      }));
    },
  },
  created() {
    this.debouncedSearch = debounce(this.fetchEmployers, 300);
  },
  beforeUnmount() {
    if (this.debouncedSearch && this.debouncedSearch.cancel) {
      this.debouncedSearch.cancel();
    }
  },
  methods: {
    formatEmployerLabel(emp) {
      const community = emp.community_name ? String(emp.community_name).trim() : '';
      const name = emp.name ? String(emp.name).trim() : '';
      const email = emp.email ? String(emp.email).trim() : '';
      // eslint-disable-next-line no-underscore-dangle
      const primary = community || name || email || emp._id;
      const secondary = [community && name, email].filter(Boolean).join(' • ');
      const detail = community ? [name, email].filter(Boolean).join(' • ') : secondary;
      return detail ? `${primary} (${detail})` : primary;
    },
    async fetchEmployers(name = '') {
      this.employersLoading = true;
      try {
        const res = await employersApi.searchEmployers({ name });
        this.employers = Array.isArray(res?.result) ? res.result : [];
      } catch (error) {
        message.error(handleResErrors(error));
      } finally {
        this.employersLoading = false;
      }
    },
    handleEmployerSearch(value) {
      this.debouncedSearch(value || '');
    },
    handleEmployerChange(value) {
      this.$emit('update:value', value || undefined);
    },
    handleDropdownVisibleChange(open) {
      if (open && !this.hasLoadedInitialEmployers) {
        this.hasLoadedInitialEmployers = true;
        this.fetchEmployers('');
      }
    },
  },
};
</script>
